<script>
    export let thumbnail;
    export let alt;
    export let url;
    export let title;
</script>

<div class="recipe-block">
    <div class="image">
        <div class="clipping">
            <a ><img  src={thumbnail} alt="{alt}"></a>
        </div>
    </div>
    <div class="title">
        <a href="{url}">{title}</a>
    </div>
</div>
